import * as types from "../../constants";
import { decryptPatientsData } from '../../utils/index.jsx'; 
/**
 * Reducer that saves all the investigations loaded
 * @constructor
 * @param {boolean} state 
 */

 const initialState = {
    data: {
        requests:null
    },
    loading: false,
    error: null
}
 
export default function reducer(state = initialState, action){
    // SHER-582: clone `data` too — the success cases reassign newState.data.* in
    // place, which with a shallow {...state} mutated the shared object and (at init)
    // polluted the module-level initialState.data, making the reset cases below a
    // no-op that still carried the previous org's requests.
    let newState = { ...state, data: { ...state.data } };
    let tempRequests;
    switch(action.type){
        case types.FETCH_REQUEST_PHARMACY_SUCCESS:
            newState.data.requests = action.requests;           
            newState.loading = initialState.loading; 
            newState.error = initialState.error;   
            return newState;
        case types.SAVE_REQUEST_PHARMACY_SUCCESS:
            tempRequests = newState.data.requests ? [...newState.data.requests] : [];
            tempRequests.push(action.request);

            newState.data.requests = tempRequests;
            newState.loading = initialState.loading; 
            newState.error = initialState.error;   
            return newState;
        case types.UPDATE_REQUEST_PHARMACY_SUCCESS:
            tempRequests = newState.data.requests ? [...newState.data.requests] : [];
            const requestIndex = tempRequests.findIndex(aRequest => aRequest.id === action.request.id);
            if(requestIndex !== -1){
                tempRequests[requestIndex] = action.request;
            }
            else{
                tempRequests.push(action.request);
            }
            newState.data.requests = tempRequests;
            newState.loading = initialState.loading; 
            newState.error = initialState.error;   
            return newState;
        case types.REQUESTS_LOADING:
            newState.loading = true;   
            return newState;
        case types.REQUESTS_ERROR:
            newState.loading = initialState.loading;   
            newState.error = action.errorCode;                           
            return newState;
        case types.REQUESTS_RESET_ERROR:
            newState.error = initialState.error;
            return newState;
        // SHER-582: requests are org-scoped but stored flat (data.requests) and were
        // never reset, so org A's requests leaked into org B on both an in-app org
        // switch and logout. Reset to a fresh initial state on both.
        case types.SELECT_INVESTIGATION:
        case types.AUTH_SIGN_OUT:
            return { ...initialState, data: { ...initialState.data } };
        default:
            return state;
    }
}